import { apiList } from "../../helpers/apiList";
import { axiosRequest } from "../../helpers/interceptorServices";

const normalize = (response) => {
  const status = response?.status ?? 0;
  const body = response?.data ?? {};
  const ok = status >= 200 && status < 300;
  return {
    ok,
    status,
    data: body,
    error: ok
      ? null
      : (typeof body.error === "string" && body.error) ||
        body.message ||
        `Something went wrong (HTTP ${status})`,
    errors: body.errors,
  };
};

const call = async (method, url, payload) =>
  normalize(await axiosRequest(method, url, payload));

export const listTemplates = (params = {}) => {
  const query = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== "") {
      query.append(key, value);
    }
  });
  const qs = query.toString();
  return call("get", `${apiList.RCS_TEMPLATES}${qs ? `?${qs}` : ""}`);
};

export const createTemplate = (body) => call("post", apiList.RCS_TEMPLATES, body);

export const getTemplate = (id) =>
  call("get", `${apiList.RCS_TEMPLATES}/${encodeURIComponent(id)}`);

export const refreshTemplateStatus = (id) =>
  call("post", `${apiList.RCS_TEMPLATES}/${encodeURIComponent(id)}/refresh-status`);

export const sendMessages = (body) => call("post", apiList.RCS_MESSAGES, body);

export const isAgentNotConfigured = (result) =>
  result.status === 403 && /RCS agent not configured/i.test(result.error || "");
